<template>
    <div class="ticket-confirm">
        <div class="summary" style="text-align: left;position: absolute;left: 10px;">
            <span>合计：</span>
            <span class="red-money">{{money | formatPrice}}</span>
        </div>
        <mobile-button class="btn-font" color="#ab2c31" @click="onSubmit" style="text-align:center;">
            {{showCancel?'提交订单':'去支付'}}
        </mobile-button>
        <!-- <mobile-button class="btn-font" color="#808080" v-if="showCancel" @click="onCancel">
            取消
        </mobile-button> -->
    </div>
</template>
<script>
    import MobileButton from "components/mobile-button/index";

    export default {
        name: "ticketConfirm",
        components: {MobileButton},
        props: {
            detail: Object,
            showCancel: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            money() {
                return this.detail.allMoney
            }
        },
        data() {
            return {}
        },
        methods: {
            onCancel() {
                this.$router.back()
            },
            onSubmit() {
                // this.$router.push({path: 'pay-confirm-second'})
                this.$emit('commit')
            },
        },
        created() {

        },
    }
</script>
<style lang="scss" scoped>

</style>
